<template lang="pug">
  #itineries.center-panel.md-scrollbar.md-theme-default
    .md-layout.heading
    md-content.md-elevation-1(md-theme="white")
      storekeepers-menu
      //.md-flex(md-theme="white")
      sort-table(
        ref="table" class="itineries-table" v-bind:columns="tableColumns" v-model="itineraries"  v-on:refresh="getItineraries" link 
        v-bind:per-page="perPage" v-bind:total="itinerariesAmount" table-id="storekeepers-itineries-table" v-on:item-click="onItemClick"
        tableHeight="calc(100% - 48px)"
        v-bind:showAddButton="false"
        v-bind:loadOnScroll="true"
      )
        template(slot="freights" slot-scope="scope") {{ scope.item.freights.length }}
        template(slot="forwarder" slot-scope="scope") {{ scope.item.forwarder !== null ? scope.item.forwarder.login : '' }}
        template(slot="date" slot-scope="scope") 
          span(v-if="scope.item.date") {{ moment(scope.item.date).format('Do MMMM (DD.MM.YYYY)') }}
          span(v-else) Не установленна

        template(slot="from_stock" slot-scope="scope") {{ scope.item.from_stock ? scope.item.from_stock.name : 'Не установлен' }}

        template(slot="to_stock" slot-scope="scope") {{ scope.item.to_stock ? scope.item.to_stock.name : 'Не установлен' }}

        template(slot="weight" slot-scope="scope")
          span(v-if="scope.item.weight") {{scope.item.weight.toFixed(2)}}
          span(v-else) Не указан

        template(slot="size" slot-scope="scope")
          span(v-if="scope.item.size") {{scope.item.size.toFixed(2)}}
          span(v-else) Не указан


        template(slot="driver" slot-scope="scope") 
          span(v-if="scope.item.driver && scope.item.driver.id") {{ (scope.item.driver && scope.item.driver.fio) ? scope.item.driver.fio : '' }}
          span(v-if="scope.item.forwarder && scope.item.forwarder.id") {{ (scope.item.forwarder && scope.item.forwarder.fio) ? scope.item.forwarder.fio : '' }}

        template(slot="actions" slot-scope="scope")
          //span
            md-button.md-icon-button.md-dense(v-on:click="toItinerary(scope.item)"): md-icon mode_edit
            md-tooltip(md-direction="top") Редактировать машрутный лист
          //span
            md-button.md-icon-button.md-dense(v-on:click="showRemoveDialog(scope.item)"): md-icon delete
            md-tooltip(md-direction="top") Удалить машрутный лист

        template(slot="status" slot-scope="scope")
          div(class="itineraries-status" v-bind:style="('color: ' + scope.item.status.color + ';')")
            span {{scope.item.status.message}}
      //md-button.md-dense(v-bind:to="{ name: 'Itinerary', params: { id: 'new' }}") Добавить машрутный лист #[md-icon add]
    md-dialog(v-bind:md-active.sync="deleteDialog" md-theme="white")
      md-dialog-title Удалить машрутный лист?
      md-dialog-actions
        md-button.md-primary(@click="deleteDialog = false") Отмена
        md-button.md-accent(@click="deleteItinerary()") Удалить
</template>
<script>
  import moment from "moment";
  import StorekeepersMenu from "./storekeepers-menu";
  import SortTable from "@/components/SortTable";
  export default {
    components: {StorekeepersMenu, SortTable},
    metaInfo() {
      return {
        title: 'Маршрутный лист',
        itemToRemove: {},
        deleteDialog: false,
      }
    },
    data() {
      return {
        title: 'Маршрутный лист',
        tableColumns: [
          { label: 'ID', field: 'id', sortable: true},
          { label: 'Тип', field: 'type_name', sortable: true},
          { label: 'Отправление', field: 'from_stock', sortable: true},
          { label: 'Назначение', field: 'to_stock', sortable: true},
          { label: 'Водитель/Экспедитор', field: 'driver', sortable: false},
          { label: 'Дата исполнения', field: 'date', sortable: true},
          { label: 'Статус', field: 'status', sortable: true},
          { label: 'Грузы', field: 'freights', sortable: false},
          { label: 'Кол-во мест', field: 'seats', sortable: false},
          { label: 'Вес (кг)', field: 'weight', sortable: false},
          { label: 'Объём (м<sup>3</sup>)', field: 'size', sortable: false},          
          { label: '', field: 'actions'}
        ],
        deleteDialog: false,
        perPage: 25
      }
    },
    computed: {
      itinerariesAmount() {
        return this.$store.state.deals.route_lists_amount;
      },
      itineraries() {
        let itineraries = this.$store.state.deals.route_lists;
        if (!itineraries || !itineraries.length) return [];

        itineraries.map(item => {
          item.routerLink = { name: 'StorekeepersItinerary', params: { id: item.id }};
        });

        return itineraries;
      }
    },
    watch: {
      '$route.name'(name) {
        if (name == 'Itineraries') this.$root.$emit('reload-table', 'storekeepers-itineries-table');
      }
    },
    methods: {
      getItineraries(page, count, orderBy, orderType, filter, reload) {
        //this.$store.dispatch('stock/getItinerary');
        this.$store.commit('deals/setCurrentItinerariesPage', page);
        let params = {
          page:       (page)      ? page      : 1,
          count:      (count)     ? count     : 50,
          order_by:   (orderBy)   ? orderBy   : 'date',
          order_type: (orderType) ? orderType : 'desc',
          filter:     (filter)    ? filter    : {model: [], relation: []},
          concat: !reload
        };
        this.$store.dispatch('deals/getRouteLists', params);
      },
      onItemClick(data) {
        this.toItinerary(data.item);
      },
      toItinerary(item) {
        this.$store.commit('stock/setCurrentItinerary', item);
        this.$router.push({name: 'Itinerary'});
      },
      showRemoveDialog(item) {
        this.itemToRemove = Object.assign({}, item);
        this.deleteDialog = true;
      },
      deleteItinerary() {
        this.deleteDialog = false;
        if (!this.itemToRemove || !this.itemToRemove.freights || !this.itemToRemove.freights.length) return;
        this.$store.dispatch('stock/deleteItinerary', this.itemToRemove.id).then(r => {
          if (r) {
              this.$store.commit('showSnackbar', ['Машрутный лист успешно удалён, обновление списка маршрутных листов...', 6000, 'success']);
              this.getItineraries();
          }
        });
        /*
        let data = this.itemToRemove.freights.map(item => item.id);
        this.$store.dispatch('stock/removeItinerary', {freights_to_delete: data}).then(r => {
          if (r) {
              this.$store.commit('showSnackbar', ['Машрутный лист успешно удалён, обновление списка маршрутных листов...', 6000, 'success']);
              this.getItineraries();
          }
        });
        */
      }
    },
    created() {
      //this.getItineraries();
      this.$root.$emit('reload-table', 'storekeepers-itineries-table');
    },
  }
</script>
<style lang="sass">
    .itineries-table
        tbody
            tr.md-table-row
                cursor: pointer
        .itineraries-status
          //margin-bottom: 15px
</style>


// WEBPACK FOOTER //
// StorekeepersItineraries.vue?5182c6ff